declare const productSiteRegion: string;
import { Injectable } from '@angular/core';
import { ProductSiteRegionEnum } from '@app/models/enums/product-site-region.enum';

@Injectable({providedIn: 'root'})
export class ProductSiteRegionService {
    private readonly fisherSciEuropeanHostSuffixes = [
        'fishersci.at',
        'fishersci.be',
        'fishersci.dk',
        'fishersci.fi',
        'fishersci.fr',
        'fishersci.de',
        'fishersci.ie',
        'fishersci.it',
        'fishersci.nl',
        'fishersci.no',
        'fishersci.pt',
        'fishersci.es',
        'fishersci.se',
        'fishersci.ch',
        'fishersci.co.uk'
    ];

    getProductSiteRegion(): ProductSiteRegionEnum {

        const hostname = window.location.hostname.toLowerCase();

        if (this.isFisherSciEuropeanHost(hostname)) {
            return ProductSiteRegionEnum.FISHERSCI_EU;
        }

        if (ProductSiteRegionEnum[productSiteRegion]) {
            return ProductSiteRegionEnum[productSiteRegion];
        }

        return null;
    }

    isThermofisher(): boolean {
        return ProductSiteRegionEnum.THERMOFISHER === this.getProductSiteRegion();
    }

    isFisherSci(): boolean {
        return [ProductSiteRegionEnum.FISHERSCI_US, ProductSiteRegionEnum.FISHERSCI_CA, ProductSiteRegionEnum.FISHERSCI_EU].includes(this.getProductSiteRegion());
    }

    isFisherSciEurope(): boolean {
        return ProductSiteRegionEnum.FISHERSCI_EU === this.getProductSiteRegion();
    }

    isFisherSciEuropeanHost(hostname: string = window.location.hostname.toLowerCase()): boolean {
        return this.fisherSciEuropeanHostSuffixes.some(domain => hostname.endsWith(domain));
    }

    getFisherSciEuropeanCountryCode(hostname: string = window.location.hostname.toLowerCase()): string | null {
        const matchedDomain = this.fisherSciEuropeanHostSuffixes.find(domain => hostname.endsWith(domain));

        if (!matchedDomain) {
            return null;
        }

        if (matchedDomain.endsWith('.co.uk')) {
            return 'GB';
        }

        return matchedDomain.split('.').pop().toUpperCase();
    }

    getFisherSciCustomerHelpSupportUrl(): string {
        let countryCode = 'US';

        if (this.isFisherSciEurope()) {
            countryCode = this.getFisherSciEuropeanCountryCode() || countryCode;
        } else if (ProductSiteRegionEnum.FISHERSCI_CA === this.getProductSiteRegion()) {
            countryCode = 'CA';
        }

        return `/${countryCode.toLowerCase()}/en/customer-help-support.html?cid=OBC_INT_20200507_XTD27A`;
    }

    getCatalogNumberLabel(): string {
        return this.isFisherSciEurope() ? 'Supplier' : 'Catalog';
    }

}
